/**
 * @module app.cm
 */


export class TaskTypeValueConverter {
    public toView(value: any, full: boolean = false): any {
        if(value === null || value === undefined) {
            return null;
        }
        switch(value) {
            case "CM.Case": {
                // TODO: use i18n and look up resource
                return full ? "Case Task" : "T";
            }
            case "CM.CarePlanGoal": {
                // TODO: use i18n and look up resource
                return full ? "Care Plan Intervention" : "I";
            }
            default: {
                return "Invalid Task Type";
            }
        }
    }
}

export class TaskTypePathValueConverter {
    public toView(value: string): any {
        if(value === null || value === undefined) {
            return null;
        }

        let path: string[] = value.split(",");

        if(path.length == 4) {
            switch(path[0]) {
                case "CM.Case": {
                    return '#/cm/case/' + path[1] + '/tasks/' + path[3];
                }
                case "CM.CarePlanGoal": {
                    return '#/cm/case/' + path[1] + '/careplan/goals/' + path[2] + '/interventions/' + path[3];
                }
                default: {
                    return null;
                }
            }
        }

    }
}
